import React, { useState, useEffect } from 'react';
import { useAppConfig } from '../../context/AppConfigContext';
import { applySiteBranding } from '../../config/siteConfig';
import styles from './NewUserHint.module.css';
import EmbeddedVideo from '../EmbeddedVideo'; 


const fallbackHints = {
  lesson_neiro: {
    ru: "Выберите тему, нажав на кружок с изображением. Это откроет блок подтем в левом верхнем углу. Нужно выбрать одну из них для изучения. В BlaBlaLingo обучение разбито не на уроки, а на соединённые друг с другом темы. Это эффективнее и правильнее. Чем больше ваш прогресс по теме, тем ярче изображение в кружке.",
    uk: "Оберіть тему, натиснувши на коло із зображенням. Це відкриє блок підтематик у лівому верхньому куті. Потрібно обрати одну з них для вивчення. У BlaBlaLingo навчання поділене не на уроки, а на взаємопов’язані теми. Це ефективніше й правильніше. Чим більший ваш прогрес у темі, тим яскравіше зображення в колі."
  },

  dialogs_neiro: {
    ru: "Нажмите на тему, чтобы начать диалог. В BlaBlaLingo обучение разбито не на уроки, а на соединённые друг с другом темы. Это эффективнее и правильнее. Чем больше ваш прогресс по теме, тем ярче изображение в кружке.",
    uk: "Натисніть на тему, щоб розпочати діалог. У BlaBlaLingo навчання поділене не на уроки, а на взаємопов’язані теми. Це ефективніше й правильніше. Чим більший ваш прогрес у темі, тим яскравіше зображення в колі."
  },

  exam_neiro: {
    ru: "Нажмите на тему, чтобы начать экзамен. Ассистент задаст вам 5 вопросов и оценит ваш уровень. В BlaBlaLingo обучение разбито не на уроки, а на соединённые друг с другом темы. Это эффективнее и правильнее. Чем чаще вы проходите экзамен по конкретной теме, тем ярче изображение в кружке.",
    uk: "Натисніть на тему, щоб розпочати іспит. Асистент поставить вам 5 запитань і оцінить ваш рівень. У BlaBlaLingo навчання поділене не на уроки, а на взаємопов’язані теми. Це ефективніше й правильніше. Чим частіше ви проходите іспит з конкретної теми, тим яскравіше зображення в колі."
  }
};


const NewUserHint = ({ source = 'lesson', onClose }) => {
  const { isNewUserInModule, t, baseLanguage, site } = useAppConfig();
  const [visible, setVisible] = useState(false);
  const [hasTriggeredClose, setHasTriggeredClose] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState('');

  useEffect(() => {
    if (isNewUserInModule || source === 'main') {
      setVisible(true);
    } else {
      if (!hasTriggeredClose && typeof onClose === 'function') {
        onClose();
        setHasTriggeredClose(true);
      }
    }
  }, [isNewUserInModule, onClose, hasTriggeredClose, source]);

  const handleClose = () => {
    setVisible(false);
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleVideoClick = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setShowVideo(true);
  };

  if (!visible && source !== "main") return null;

	let hint =
	  t.newUserBlock?.[source] ||
	  fallbackHints[source]?.[baseLanguage] ||
	  fallbackHints[source]?.ru ||
	  t.newUserBlock?.default ||
	  '👋 Добро пожаловать!';
	hint = applySiteBranding(hint);


  let buttonText = t.newUserBlock?.understood || 'Ок';

	if (source === 'main' && (baseLanguage === 'ru' || baseLanguage === 'uk')) {
	  hint =
		baseLanguage === 'uk'
		  ? 'Ласкаво просимо до BlaBlaLingo! Ми покажемо, як тут усе працює 👇'
		  : 'Добро пожаловать в BlaBlaLingo! Мы покажем, как всё устроено 👇';
	  hint = applySiteBranding(hint);

	  buttonText = baseLanguage === 'uk' ? 'Закрити' : 'Закрыть';
	}

  return (
    <>
      <div className={styles.hintOverlay}>
        <div className={styles.hintBox}>
          <p>{hint}</p>

          <div className={styles.buttonGroup}>

            {source === 'lesson_neiro' && (baseLanguage === 'ru' || baseLanguage === 'uk') && (
				<button
				  onClick={() => setShowVideo(true)}
				  className={styles.videoButton}
				>
				  {baseLanguage === 'uk' ? '📺 Відеоінструкція' : '📺 Видеоинструкция'}
				</button>
            )}

            <button onClick={handleClose}>{buttonText}</button>
          </div>
        </div>
      </div>

      {showVideo && (
        <EmbeddedVideo
          videoId={source === 'lesson_neiro'
            ? `${site}/backend/assets/video/lessons.mp4`
            : selectedVideo}
          title="Видеоинструкция"
          onClose={() => {
            setShowVideo(false);
            setSelectedVideo('');
          }}
        />
      )}
    </>
  );
};
export default NewUserHint;

